import { CloverOutlineIcon } from './CloverOutlineIcon';

/**
 * author: Jeff Anders
 * id 6518E183-1362-4363-ACAF-21FECEA87732
 * name clover-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clover-outline.svg
 * tags
 * - Nature 
 */
export const LuckOutlineIcon = CloverOutlineIcon;
export default LuckOutlineIcon